import Validators from '../validators'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => store.createEmbededEntityState({
  lastSave: 'flyprivateCategories',
  timeRestriction: 'flyprivateCategories',
  attrs: ['id', 'enum_value', 'order', 'regions', 'valid_from', 'valid_to'],
  titles: [
    store.__('ID'), store.__('category'), store.__('order'), store.__('region'),
    store.__('valid from'), store.__('valid to')
  ],
  _sortField: 'order',
  initVals: (row) => ({ control_timestamp: Math.round(new Date().getTime()) }),
  validators: {
    enum_value: Validators.isMandatory(store),
    valid_from: [
      Validators.isMandatoryDate(store),
      Validators.isValidFromTo(store)
    ],
    valid_to: [
      Validators.isMandatoryDate(store),
      Validators.isValidFromTo(store)
    ],
    order: [
      Validators.isMandatory(store),
      Validators.positiveInt(store)
    ],
    regions: [
      Validators.isMandatory(store),
      Validators.regionTest(store)
    ],
    _global: (vals, values) => {
      if (!vals.has) {
        vals.has = (k) => vals[k] || false
        vals.get = (k) => vals[k] || null
        vals.set = (k, v) => { vals[k] = v }
      }
      const validFrom = vals.has('valid_from') && new Date(vals.get('valid_from'))
      const validTo = vals.has('valid_to') && new Date(vals.get('valid_to'))
      const isOverlapping = (cStart, cEnd, nStart, nEnd) => {
        const cRange = cStart && cEnd && moment.range(cStart, cEnd)
        const nRange = nStart && nEnd && moment.range(nStart, nEnd)
        return cRange.overlaps(nRange) || nRange.overlaps(cRange) ||
          moment(cStart).format('YYYY-MM-DD') === moment(nEnd).format('YYYY-MM-DD') ||
          moment(nStart).format('YYYY-MM-DD') === moment(cEnd).format('YYYY-MM-DD')
      }

      if (values && vals.has('regions') && vals.get('regions') !== 'WW') {
        const regionWW = values.filter((item) => {
          const itemFrom = new Date(item.valid_from)
          const itemTo = new Date(item.valid_to)
          if (((item.id && vals.get('id') !== item.id) ||
          (item.control_timestamp && item.control_timestamp !== vals.get('control_timestamp'))) &&
          vals.get('enum_value') === item.enum_value &&
          item.regions === 'WW' && itemFrom <= validFrom && itemTo >= validTo
          ) {
            return item
          }
        })
        store.manipWarning = (!regionWW || !regionWW.length) || false
      } else {
        store.manipWarning = false
      }

      // regions and -regions
      const countries = store.options.get('Countries')
      const getRegions = (regions) => {
        if (!regions || !regions.length) {
          return ['']
        } else if (regions === 'WW') {
          return ['WW']
        }
        const splitRegions = (regions.charAt(0) === '-' ? regions.substring(1) : regions).split(',')
        return regions.charAt(0) === '-'
          ? countries.map(country => !splitRegions
            .find(region => region === country.value) && country.value)
            .filter(result => result && result.length <= 2)
          : splitRegions
      }
      const regions = vals.get('regions') && vals.get('regions').length > 0
        ? getRegions(vals.get('regions'))
        : []

      // validate distictive intervals of other record with same category
      const overlapping = []
      values && regions && regions.forEach(reg => {
        return values.filter((i) => {
          if (vals.get('enum_value') !== i.enum_value ||
              (vals.get('enum_value') === i.enum_value && reg !== i.regions) ||
              (i.id && vals.get('id') === i.id) ||
              (i.control_timestamp && i.control_timestamp === vals.get('control_timestamp'))
          ) {
            return // cut off the row with wrong enum value and current item
          }
          if (validFrom && validTo && isOverlapping(validFrom, validTo, new Date(i.valid_from), new Date(i.valid_to))) {
            overlapping.push(i)
            return i
          }
        })
      })

      if (overlapping && overlapping.length > 0) {
        return overlapping.map((item) => {
          return `${store.__('Selected interval overlaps with category/region:')} ${item.enum_value}/${item.regions}. `
        })
      }
    }
  }
})
